export default "__VITE_ASSET__NQtLQQ40__"